<template>
  <div class="menuFrame">
    <section id="login">
      <div class="container">
        <div class="row flex-nowrap mx-2 pt-3 justify-content-between align-items-center">
          <a href="https://www.chanchao.com.tw/">
            <div class="d-flex">
              <img src="../../assets/images/ChanChaoLogo.png" class="navLogo my-2" />
              <div class="ml-2">
                <div class="navHead font-weight-nomal">展昭會員</div>
                <p class="text-muted navCnt">ChanChao Member</p>
              </div>
            </div>
          </a>

          <div class="d-flex mr-3">
            <router-link to="/en/forgetPw">
              <img src="../../assets/images/lang.svg" style="width: 17px; height: 17px" class="mb-1 mr-md-0 mr-2" />
              <span class="navEnText text-muted mr-3"> English </span>
            </router-link>

            <router-link to="/vn/forgetPw">
              <img src="../../assets/images/vn.svg" style="width: 17px; height: 17px" class="mb-1" />
              <span class="navEnText text-muted"> Tiếng Việt </span>
            </router-link>
          </div>
        </div>
      </div>

      <div class="container">
        <div class="row formFrame m-1 py-2">
          <div class="rightline col-md-7 my-4 px-4">
            <div class="d-flex align-items-center">
              <img src="../../assets/images/PwIcon.png" class="mr-2 mb-2" style="width: 40px; height: 40px" alt="" />
              <h4>忘記密碼</h4>
            </div>
            <p class="my-4">請輸入您申請帳號時填寫的電子郵件地址，我們會立即將密碼重設信寄到您的信箱。</p>
            <form>
              <div class="form-group h6">
                <label for="forgetpwEmail">電子郵件地址</label>
                <input
                  type="email"
                  class="form-control"
                  id="forgetpwEmail"
                  maxlength="50"
                  aria-describedby="emailHelp"
                  placeholder="請輸入您註冊時的電子郵件"
                  v-model="email"
                  name="email"
                  :class="{ 'is-invalid': errors.first('email') }"
                  v-validate="'required|email'"
                  ref="forgetpwEmail"
                />
                <span class="text-danger" style="font-size: 10px" v-if="errors.first('email')"
                  >{{ errors.first('email') }}
                </span>
              </div>

              <div class="form-group h6">
                <label for="forgetpwcode">驗證碼</label>
                <div class="d-flex justify-content-center align-items-center">
                  <input
                    type="text"
                    class="form-control mr-1"
                    id="forgetpwcode"
                    maxlength="5"
                    placeholder="驗證碼不分大小寫"
                    v-model="validcode"
                    name="text"
                    :class="{ 'is-invalid': errors.first('text') }"
                    v-validate="'required'"
                    ref="forgetpwcode"
                  />
                  <img
                    :src="getsrc"
                    class="img-fluid rounded"
                    @click.prevent="resetValidcode"
                    style="width: 120px; height: 35px"
                  />
                  <a href="#" @click.prevent="resetValidcode">
                    <i class="ml-2 fas fa-redo" style="font-size: 25px"></i>
                  </a>
                </div>
                <span class="text-danger" style="font-size: 10px" v-if="errors.first('text')">驗證碼欄位不能留空 </span>
              </div>

              <button type="submit" class="btn btn-block btn-primary mt-4" @click.prevent="getResetlink">
                重設密碼
              </button>
            </form>

            <div v-if="!Registered">
              <hr />

              <div class="linkFrame">
                <a href="https://www.chanchao.com.tw/accounts/login">會員登入</a>

                <!-- <router-link to="/login">會員登入</router-link> -->
                <span class="linkText ml-2 pl-2">
                  <span class="linkLine"></span>
                  <!-- <router-link to="/signup">立即註冊</router-link> -->
                  <a href="https://www.chanchao.com.tw/accounts/signup">立即註冊</a>
                </span>
              </div>
            </div>
          </div>

          <div class="col-md-5 my-4 px-4 lineBottom">
            <div class="d-flex align-items-center mb-4">
              <i class="fas fa-2x fa-question-circle mr-3 mb-2" style="color: #ffa042"></i>
              <h4>常見問題</h4>
            </div>
            <p style="font-weight: bold">Q: 為何收不到 E-mail 或驗證碼</p>
            <hr />

            <ol class="ml-0 pl-3">
              <li style="font-size: 15px" class="font-weight-bold mb-3">是否被歸類於「垃圾信件」?</li>
              <p style="font-size: 14px">
                請至「垃圾信件」匣查找是否被歸類予垃圾信件，如找到請選取此封郵件，並設定為「非垃圾信」，下次寄發則會寄發到「收件匣」。
              </p>

              <li style="font-size: 15px" class="font-weight-bold mb-3">填入電子郵件後，等不到驗證碼 ?</li>
              <p style="font-size: 14px">
                可稍後幾分鐘等候系統發出，如依然未收到，或許輸入錯的E-mail帳號，可重新輸入帳號嘗試申請。
              </p>

              <div class="d-flex mt-3">
                <a href="//www.chanchao.com.tw/qa.asp" target="_blank"
                  >更多常見問題<i class="fas fa-external-link-alt ml-2"></i
                ></a>
              </div>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
  import Footer from '@/components/footer.vue'

  export default {
    components: {
      Footer,
    },

    data() {
      return {
        getsrc: '',
        email: '',
        validcode: '',
        alertTitle: '',
        alertText: '',
        lastUrl: '',
        CSRF_Token: '',
        Registered: false,
      }
    },

    watch: {
      email: function () {
        const vm = this
        vm.$refs.forgetpwEmail.style.borderColor = '#ced4da'
      },

      validcode: function () {
        const vm = this
        vm.$refs.forgetpwcode.style.borderColor = '#ced4da'
      },
    },

    methods: {
      getResetlink() {
        const vm = this
        if (vm.lastUrl.length === 0) {
          vm.lastUrl = 'https://www.chanchao.com.tw/'
        }

        const linkinfo = {
          Email: vm.email,
          Validcode: vm.validcode,
          CSRF: vm.CSRF_Token,
        }

        const url = 'https://www.chanchao.com.tw/apiLogin/v1/forgetPw/tw'

        vm.$validator.validate().then((valid) => {
          if (valid) {
            vm.$http.post(url, linkinfo).then(function (response) {
              // // console.log(response)
              if (response.data == '200') {
                vm.alertTitle = '成功'
                vm.alertText = '密碼重設信已成功寄出！'
                vm.alertSuccess()
              } else if (response.data == '252') {
                vm.alertText = '您的帳號已被停用！'
                vm.alertError()
                vm.$refs.forgetpwEmail.style.borderColor = 'red'
              } else if (response.data == '253') {
                vm.alertText = '您尚未加入會員！'
                vm.alertError()
                vm.$refs.forgetpwEmail.style.borderColor = 'red'
              } else if (response.data == '254') {
                vm.alertText = '您的電子郵件地址輸入錯誤，或尚未加入展昭會員！'
                vm.alertError()
                vm.$refs.forgetpwEmail.style.borderColor = 'red'
              } else if (response.data == '255') {
                vm.alertText = '請輸入您的電子郵件地址！'
                vm.alertError()
                vm.$refs.forgetpwEmail.style.borderColor = 'red'
              } else if (response.data == '256') {
                vm.alertText = '驗証碼錯誤，請重新輸入！'
                vm.alertError()
                vm.$refs.forgetpwcode.style.borderColor = 'red'
              } else if (response.data == '257') {
                window.location.replace('https://www.chanchao.com.tw/')
              } else {
                vm.alertText = '系統忙碌，請稍後登入！'
                vm.alertError()
              }
            })
          } else {
            vm.alertText = '輸入欄位不完整，請重新檢查！'
            vm.alertError()
          }
        })
      },

      alertError() {
        const vm = this

        vm.$swal({
          // title: vm.alertTitle,
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',
          // animation: false,
          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },

      alertSuccess() {
        const vm = this

        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'success',
          confirmButtonText: 'OK',
          // animation: false,
          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        }).then(function () {
          document.location.href = 'https://www.chanchao.com.tw/accounts/login'
        })
      },

      resetValidcode() {
        const vm = this
        vm.$http.get('https://www.chanchao.com.tw/apiLogin/v1/Validcode').then((response) => {
          vm.getsrc = response.data
        })
      },
    },

    created() {
      const vm = this
      vm.$http.get('https://www.chanchao.com.tw/apiLogin/v1/Validcode').then((response) => {
        vm.getsrc = response.data
      })

      vm.$http.get('https://www.chanchao.com.tw/apiLogin/v1/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      //更換英文語系
      vm.$i18n.locale = 'zhTW'

      //是否登入狀態

      //取cookie
      // vm.access_token = vm.$cookies.get('as')

      // if (vm.access_token) {
      const url = 'https://www.chanchao.com.tw/apiLogin/v1/isAuthenticated'
      const info = null

      vm.$http.post(url, info).then(function (response) {
        // console.log(response.data)
        if (response.data == 200) {
          vm.Registered = true
        } else {
          vm.Registered = false
        }
      })
    },
  }
</script>

<style lang="scss" scoped>
  //Swal setting

  .swal2-popup {
    font-size: 13px !important;
  }

  .swal2-styled.swal2-confirm {
    font-size: 10px;
  }
  #main-footer {
    bottom: 0;
  }

  .menuFrame {
    background-color: #f2f2f2;
    min-height: 100%;
  }

  .formFrame {
    background-color: #ffffff;
    margin-top: 40px;
    border-radius: 10px;
    box-shadow: 1px 1px 1px 1px rgba(201, 199, 199, 0.5);
  }

  .rightline {
    border-right: 1px solid #ccc;
  }

  .navEnText:hover {
    color: rgb(34, 34, 34) !important;
  }

  .navHead {
    font-size: 29px;
    color: #2c3e50;
  }

  .navCnt {
    font-size: 17px;
  }

  .navLogo {
    height: 55px;
  }

  @media (max-width: 768px) {
    .rightline {
      border-right: 0px;
    }

    .lineBottom {
      border-top: 0.5px solid rgb(230, 227, 227);
      padding-top: 30px;
    }

    .navEnText {
      display: none;
    }

    .navHead {
      font-size: 23px;
      color: #2c3e50;
    }

    .navCnt {
      font-size: 14px;
    }

    .navLogo {
      height: 50px;
      width: 100px;
    }
  }

  @media (max-width: 992px) {
    .auth-code {
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }

  .input-note {
    font-size: 14px;
    color: rgb(190, 67, 67);
  }

  input::-webkit-input-placeholder {
    /* placeholder*/
    color: #aab2bd;
    font-size: 14px;
  }

  .linkFrame {
    font-size: 15px;
  }

  .linkText {
    position: relative;
  }

  .linkLine {
    position: absolute;
    height: 13px;
    //width: 33px;
    top: 20%;
    left: 0;
    border-left: 2px solid #a1a7a8;
  }
</style>
